import React from 'react';
import { Box, TextField, InputAdornment } from '@mui/material';
import {
  GridToolbarContainer,
  GridToolbarColumnsButton,
  GridToolbarFilterButton,
  GridToolbarDensitySelector,
  GridToolbarExport,
  gridFilteredSortedRowIdsSelector,
  QuickFilter,
  QuickFilterControl,
  QuickFilterClear,
} from '@mui/x-data-grid-pro';
import SearchIcon from '@mui/icons-material/Search';
import ClearIcon from '@mui/icons-material/Clear';
import GridToolbarRefreshButton from './GridToolbarRefreshButton';

import * as styles from './DataGridToolbar.scss';

// Function that returns an array of all filtered and sorted rows. Used for
// CSV export to include all rows instead of just rows in the current page.
const getAllFilteredRows = ({ apiRef }) => gridFilteredSortedRowIdsSelector(apiRef);

// Customized toolbar for the DataGrid
const DataGridToolbar = (props) => {
  const {
    actionButtons,
    showQuickFilter,
    enableFilterButton,
    enableColumnsButton,
    enableDensityButton,
    enableExportButton,
    enableRefreshButton,
    refreshFn,
    isRefreshing,
  } = props;

  return (
    <div className={styles.brDataGridToolbar}>
      <GridToolbarContainer>
        {showQuickFilter && <QuickFilter className="quickFilter" expanded>
          <QuickFilterControl
            render={({ ref, ...other }) => (
              <TextField
                {...other}
                sx={{ width: 260 }}
                inputRef={ref}
                aria-label="Search"
                placeholder="Search..."
                size="small"
                variant="outlined"
                slotProps={{
                  input: {
                    startAdornment: (
                      <InputAdornment position="start">
                        <SearchIcon fontSize="small" />
                      </InputAdornment>
                    ),
                    endAdornment: other.value ? (
                      <InputAdornment position="end">
                        <QuickFilterClear
                          edge="end"
                          size="small"
                          aria-label="Clear search"
                          material={{ sx: { marginRight: -0.75 } }}
                        >
                          <ClearIcon fontSize="small" />
                        </QuickFilterClear>
                      </InputAdornment>
                    ) : null,
                    ...other.slotProps?.input,
                  },
                  ...other.slotProps,
                }}
              />
            )}
          />
        </QuickFilter>}
        <div className="MuiDataGrid-toolbarButtons">
          {enableFilterButton && <GridToolbarFilterButton
            slotProps={{
              button: { variant: 'outlined' },
            }}
          />}
          {enableColumnsButton && <GridToolbarColumnsButton
            slotProps={{
              button: { variant: 'outlined' },
            }}
          />}
          {enableDensityButton && <GridToolbarDensitySelector
            slotProps={{
              button: { variant: 'outlined' },
            }}
          />}
          {enableExportButton && <GridToolbarExport
            slotProps={{
              button: { variant: 'outlined', size: 'small' },
            }}
            csvOptions={{
              getRowsToExport: getAllFilteredRows,
            }}
            printOptions={{
              disableToolbarButton: true,
            }}
          />}
          {enableRefreshButton && <GridToolbarRefreshButton onClick={refreshFn} loading={isRefreshing} />}
        </div>
        <Box sx={{ flexGrow: 1 }} />
        <div className="MuiDataGrid-toolbarActionButtons">
          {actionButtons}
        </div>
      </GridToolbarContainer>
    </div>
  );
};

export default DataGridToolbar;
